module.exports = __webpack_public_path__ + "static/media/SC_H_08.49bd7267.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/clothes/faces/SC_H_08.png
// module id = 179
// module chunks = 0